import { Grid } from '@mui/material'
import { SelectC, TextFieldC } from 'components'
import { useFormContext } from 'react-hook-form'

const logicalFieldOptions = [
  {
    id: '1',
    name: 'SIM'
  },
  {
    id: '0',
    name: 'NÃO'
  }
]

export function DirtRoadForm() {
  const { watch } = useFormContext()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {/* <SwitchC name="hasDirtRoadQuiz" label="Estrada de chão" /> */}
        <SelectC
          name="hasDirtRoadQuiz"
          label="Estrada de chão"
          options={logicalFieldOptions}
          getOptionLabel={(option: any) => option?.name}
        />
      </Grid>
      {watch('hasDirtRoadQuiz')?.id === '1' && (
        <>
          <Grid item xs={12}>
            <TextFieldC
              name="dirtRoadQuizQuest1"
              label="Quantos km de estrada de chão?"
              normalize={(value) =>
                value.replace(/\D/g, '').replace(/(\d{1,2})$/, '.$1')
              }
            />
          </Grid>
          <Grid item xs={12}>
            <SelectC
              name="dirtRoadQuizQuest2"
              options={logicalFieldOptions}
              label="Entra carreta no local e a mesma consegue fazer o retorno?"
              getOptionLabel={(option: any) => option?.name}
            />
          </Grid>
          <Grid item xs={12}>
            <SelectC
              name="dirtRoadQuizQuest3"
              options={logicalFieldOptions}
              label="Em caso de chuva, o caminhão consegue chegar até o local?"
              getOptionLabel={(option: any) => option?.name}
            />
          </Grid>
          <Grid item xs={12}>
            <SelectC
              name="dirtRoadQuizQuest4"
              options={logicalFieldOptions}
              label="Já anexou a localização da entrega?"
              getOptionLabel={(option: any) => option?.name}
            />
          </Grid>
        </>
      )}
    </Grid>
  )
}
